const inFlightPromises = {}

const state = {
  evaluations: {},
  loading: {}
}

const mutations = {
  setEvaluation (state, { offerId, data }) {
    state.evaluations = {
      ...state.evaluations,
      [offerId]: data
    }
  },

  setLoading (state, { offerId, value }) {
    state.loading = {
      ...state.loading,
      [offerId]: value
    }
  },

  clearEvaluation (state, offerId) {
    const newEvaluations = { ...state.evaluations }
    delete newEvaluations[offerId]
    state.evaluations = newEvaluations
  }
}

const actions = {
  async fetchEvaluation ({ commit, state }, { offerId, force, vm }) {
    if (!force && state.evaluations[offerId]) {
      console.log('[AI] Offer', offerId, '- already cached, skipping')
      return state.evaluations[offerId]
    }
    if (inFlightPromises[offerId]) {
      console.log('[AI] Offer', offerId, '- already in-flight, joining existing request')
      return inFlightPromises[offerId]
    }

    console.log('[AI] Offer', offerId, '- starting evaluation...')
    const startTime = Date.now()
    commit('setLoading', { offerId, value: true })

    inFlightPromises[offerId] = (async () => {
      try {
        const data = await vm.$caller.request('post', '/ai_evaluate_offer', 'admin_headers', {
          offer_id: offerId,
          force: force || false
        })
        const elapsed = ((Date.now() - startTime) / 1000).toFixed(1)
        console.log('[AI] Offer', offerId, '- completed in', elapsed + 's', data.summarizer ? '(' + data.summarizer.decision + ')' : '')
        commit('setEvaluation', { offerId, data })
        return data
      } catch (err) {
        console.error('[AI] Offer', offerId, '- ERROR:', err.message)
        const errorData = { status: 'error', error: err.message || 'Unknown error' }
        commit('setEvaluation', { offerId, data: errorData })
        return errorData
      } finally {
        commit('setLoading', { offerId, value: false })
        delete inFlightPromises[offerId]
      }
    })()

    return inFlightPromises[offerId]
  }
}

const getters = {
  getEvaluation: (state) => (offerId) => {
    return state.evaluations[offerId] || null
  },

  isLoading: (state) => (offerId) => {
    return state.loading[offerId] || false
  },

  getProposerText: (state) => (offerId) => {
    const evaluation = state.evaluations[offerId]
    if (evaluation && evaluation.proposer && evaluation.proposer.reasoning) {
      return evaluation.proposer.reasoning
    }
    return null
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
